import { ApolloError, gql, useLazyQuery } from '@apollo/client';
import { ProductType } from '../../types/products.types';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

const GET_CRM_ALL_PRODUCTS_LAZY = gql`
  query getCRMAllProducts($filters: ProductsFilter) {
    getCRMAllProducts(filters: $filters) {
      productExternalID
      productID
      productName
      therapeuticArea
      isInCountry
      CRMTherapeuticArea
      productType
    }
  }
`;

type UseGetCRMAllProductsLazy = () => {
  getCRMAllProductsLazy: Function;
  loading: boolean;
  error?: ApolloError;
  data: ProductType[];
};

type ResultType = {
  getCRMAllProducts: ProductType[];
};

const useGetCRMAllProductsLazy: UseGetCRMAllProductsLazy = () => {
  const [getCRMAllProductsLazy, { data, loading, error }] = useLazyQuery<ResultType>(GET_CRM_ALL_PRODUCTS_LAZY, {
    fetchPolicy: 'cache-and-network',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });

  if (error) {
    const customContext = extractApolloErrorDetails(error);
    Logger.logError({
      error,
      customContext,
      transactionName: 'getCRMAllProductsLazy.ts - useGetCRMAllProductsLazy',
    });
  }

  return {
    getCRMAllProductsLazy,
    data: data?.getCRMAllProducts || [],
    loading,
    error,
  };
};
export default useGetCRMAllProductsLazy;
